/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider, MuiThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Divider, TextField, Grid, Button, Link, IconButton, Tooltip } from '@material-ui/core'

import TicketConfig from './TicketConfig';
import Actions from '../../fluid/Actions/ActionFactory';
import Evaluate from '../../fluid/Utilities/evaluate';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import FileCopy from '@material-ui/icons/FileCopy';
import lightBlue from '@material-ui/core/colors/lightBlue';
const styles = theme => ({
    text_field : {
        width : '30%',
    },

    title: {
        fontSize: 14,
      },
      pos: {
        marginBottom: 12,
      },

      divider: {
          margin: "8px 0px"
      },

      modules: {
          marginRight: "12px",
          
      }
})

const blueTheme = createMuiTheme({ 
    palette: { 
        primary: {
            main: lightBlue[600]
        } 
    },
    typography: {
        useNextVariants: true,
        h6: {
            fontSize: '0.95rem',
            lineHeight: 1.3
        },
        body2Next: {
            fontSize: "0.75rem"
        }
    }
})

const commands = ['--eval', '--path']

class Ticket extends Component {
    state = {
        
    }

    componentWillMount(){

    }


   

    getLabelsAndValues = ( resultObj, compareDisplayObj ) => {
     
        let isCompareObjArr = Array.isArray(compareDisplayObj)
        if(isCompareObjArr){
            let evaluatedArr = [];
            compareDisplayObj.map((element) => {
                let evalObj = this.getEvaluatedObj(resultObj, element)
                evaluatedArr.push(evalObj)     
            })

            evaluatedArr = evaluatedArr.filter(function( element ) {
                return element !== undefined;
            });

            return evaluatedArr
          
        } else {
         
            let evaluated = this.getEvaluatedObj( resultObj, compareDisplayObj)
            return evaluated
        } 
        
       
    }


    getEvaluatedObj = ( obj, compareDisplayObj ) => {
        let evaluatedObj;
        let isNameEqual = false;
        let evaluatedResult ;
        let isResultArray = Array.isArray(obj);

        if(isResultArray){
            for( let i = 0; i < obj.length;  i++ ){
                console.log("index")
                console.log(obj[i])
                evaluatedResult = this.getEvaluatedResult(obj[i], compareDisplayObj);
                if(evaluatedResult !== undefined){
                    evaluatedObj = evaluatedResult;
                    isNameEqual = true;
                }

                if(isNameEqual == true){
                    break;
                }
            }
        } else {
            evaluatedObj = this.getEvaluatedResult(obj, compareDisplayObj);
        }
       
        return evaluatedObj;
        
    }


    getEvaluatedResult = ( obj, compareDisplayObj ) => {
        let evaluatedResult;

      {/*  let resultKeys = Object.keys(obj);
        let resultValues = Object.values(obj);


        for( let i = 0; i < resultKeys.length ; i++){
            if(typeof resultValues[i] === 'object'){
                return this.getEvaluatedResult(resultValues[i], compareDisplayObj)
            } else {
                if( obj.name === compareDisplayObj.name){
                    //let val = obj.value;
                    let val = this.getValue(obj.value)
                    evaluatedResult =  { value : val, label: compareDisplayObj.label}
                    break;
                }
            }
        }  */}
        
        if(obj.name === compareDisplayObj.name){
            let val = this.getValue(obj.value)
            evaluatedResult =  { value : val, label: compareDisplayObj.label}
        }
        
        return evaluatedResult;
    }
    getValue = ( val ) => {
        let objValues = Object.values(val)
        let value = objValues.filter((element) => element != null || element != undefined)
                        .reduce(function(acc, element){
                            return element;
                    })
        return value;
    }

    renderEscalateButton = () => {
      
            return (
               
                <Tooltip title = 'Escalate'>
                    <Button variant = 'outlined' color = 'secondary' size = 'small' onClick={this.props.escalate}>Escalate</Button>
                </Tooltip>
               
            )
      
    
    }
    renderTicketCardHeader = () => {
        
        let { identifier } = this.props.config.displayLabels;
        let { result } = this.props.config;
        let { wv_field_list } = result
        let evaluatedObj = this.getLabelsAndValues(wv_field_list, identifier );
       
        return (
            <CardHeader
                        aria-label={ evaluatedObj.label }
                        action={ this.props.type == 'resolve' &&  this.renderEscalateButton()}
                        titleTypographyProps = {{
                            variant: 'overline',
                            color: 'textSecondary'
                        }}
                        subheaderTypographyProps = {{
                            variant: 'h6',
                            color: 'primary',
                            tabIndex : 0
                        }}
                        title = { evaluatedObj.label }
                        subheader = {
                            <Typography> {evaluatedObj.value} </Typography>
                        }
                    ></CardHeader>
        )
    }

    renderModules = () => {
        
        let { modules } = this.props.config.displayLabels;
        let { result } = this.props.config;
        let { wv_field_list } = result;
        let evaluatedModules = this.getLabelsAndValues(wv_field_list, modules)
        const { classes } = this.props

        return (
            <Fragment>
                <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                    {
                        evaluatedModules.map((module, index) => (
                            <div style = {{display: 'inline', marginRight: '20px'}} key={index}>
                                <Typography inline = {true} variant = 'overline' gutterBottom = {false} color = 'primary'>{module.label}:  </Typography>
                                <Typography inline = {true} variant = 'caption' gutterBottom = {false}>{module.value}</Typography>
                            </div >
                          //  <Typography variant='button' className={classes.modules}> <b>{ module.label } </b>: {module.value}</Typography>
                        ))
                    }
                </div>
            </Fragment>
        )
    }
    
    renderIssue = () => {
        
        let { issue } = this.props.config.displayLabels;
        let { result } = this.props.config;
        let { wv_field_list } = result;
        let evaluatedIssue = this.getLabelsAndValues(wv_field_list, issue);

      
        const { classes } = this.props
        return (
            <Fragment>
                 {
                    evaluatedIssue.map((issue) => (
                        <Fragment key={issue}>
                            <Typography variant='button' dangerouslySetInnerHTML={{__html: issue.label}}></Typography>
                            <Typography variant='body2' style= {{"white-space": "pre-line"}} dangerouslySetInnerHTML={{__html: issue.value}}></Typography>
                            <Divider className={ classes.divider }></Divider>
                        </Fragment>
                    ))
                 }
            </Fragment>
        )
    }

    renderResolution = () => {
        let { type } = this.props;
       
        let { resolution } = this.props.config.displayLabels;
        let { result } = this.props.config;
        let { wv_field_list } = result;
        let evaluatedResolution = this.getLabelsAndValues(wv_field_list, resolution);
        const { classes } = this.props
        return (
            <Fragment>
                 {
                    evaluatedResolution.map((resolution) => (
                        <Fragment key={resolution}>
                            <Typography variant='button' dangerouslySetInnerHTML={{__html: resolution.label}}></Typography>
                            <Typography variant='body2' dangerouslySetInnerHTML={{__html: resolution.value}}></Typography>
                            <Divider className={ classes.divider} /> 
                        </Fragment>
                    ))
                 }
            </Fragment>
        )
    }

    renderCopyResolution = () => {
        const { ticket_resolution } = this.props.config.result;
        return (
            <Tooltip title = 'Copy Resolution'>
                        <Button variant = 'text' color = 'primary'  fullWidth onClick = {(event) => {
                            event.preventDefault();
                            this.props.copyResolution(ticket_resolution); 
                            
                            }}>
                            <FileCopy style = {{width: '20px', marginRight: '10px'}}/>
                            COPY RESOLUTION</Button>
                    </Tooltip> 
            
        )
    }
 
    render() {
      //  this.getObj()
        const { classes } = this.props;
        return (
            <MuiThemeProvider theme={blueTheme}>
                <Card elevation = {1} square style = {{width : '100%', height : 'auto', padding: '8px', marginBottom: "8px"}}>
                    {
                        this.renderTicketCardHeader()
                    }
                    <CardContent>          
                        {
                            this.renderModules()
                        }
                        <Divider className={ classes.divider} />
                        {
                            this.renderIssue()
                        }     
                        
                        {
                            this.props.type == 'recommendation' && (
                                <Fragment>
                                    {
                                        this.renderResolution()
                                    }
                                    
                                </Fragment>
                            )
                        }
                       
                    </CardContent>
                    {
                        this.props.type == 'recommendation' && (
                            <CardActions>
                                {
                                    this.renderCopyResolution()
                                }
                            </CardActions>
                        )
                    }
                    
                </Card>
            </MuiThemeProvider>
        );
    }
}

export default withStyles(styles)(Ticket);